<div class="top">
  <div class="heading">
    <h1>My Sprints</h1>
  </div>

  <div id="table-container" [hidden]="!dataLoaded">
    <div class="scrollable">
      <table id="sprint-table" mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="name">
          <td class="name" mat-cell *matCellDef="let sprint">
            <a routerLink="/sprint/{{sprint.id}}">{{sprint.name}}</a>
          </td>
        </ng-container>

        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>

  <app-command-bar></app-command-bar>

  <div [hidden]="dataLoaded">
    <mat-spinner></mat-spinner>
  </div>
</div>
